import axios from 'axios';
const API_URL = process.env.VUE_APP_API_BASE;
class AuthService {
    login(username, password) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_ENDPOINT_LOGIN, {
                username,
                password,
                custom_auth: true
            }, {
                headers: {
                    'Authorization' : ''
                }
            })
                .then((response) => {
                    const {status, data} = response;
                    if(status === 200 && data.id !== undefined && data.token) {
                        localStorage.setItem('user', JSON.stringify(data));
                        localStorage.setItem('jwt', JSON.stringify(data.token));
                    }
                    resolve(response);
                }, (error) => {
                    reject(error);
                });
        });
    }
    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('jwt');
    }
    register(user) {
        return axios.post(API_URL + 'signup', {
            username: user.username,
            email: user.email,
            password: user.password
        });
    }
}
export default new AuthService();
